import React from 'react';

class Image extends React.Component {
    constructor(props) {
        super(props);

        // Defaults
        this.width = this.props.width || 307.5;
        this.height = this.props.height || 200;

        // Set state
        this.state = {
            focalX: 0.5,
            focalY: 0.5,
            focalZ: 1,
            sizes: {
                small: {
                    media: "(max-width: 575px)",
                    width: 190,
                    height: Math.round((190 / this.width) * this.height),
                },
                normal: {
                    media: "(min-width: 576px)",
                    width: this.width,
                    height: this.height,
                },
            },
            formats: ['webp', 'jpg'],
        };
    }

    componentDidMount() {
        // Get values from attributes
        this.setState(() => ({
            focalX: this.props.focalX || this.state.focalX,
            focalY: this.props.focalY || this.state.focalY,
            focalZ: this.props.focalZ || this.state.focalZ,
            formats: this.props.formats || this.state.formats,
        }));
    }

    render() {
        const pattern = new RegExp('^https?:', 'i');
        const isFullUrl = pattern.test(this.props.image);

        const image = isFullUrl ? this.props.image : window.imgixUrl + this.props.image;
        const stateData = this.state;

        const imgixPattern = new RegExp(`^${window.imgixUrl.replace(/[-[/\]{}()*+?.,\\^$|#\s]/g, '\\$&')}.*`, 'i');
        const isImgix = imgixPattern.test(image);

        if (!isImgix) {
            const paddingBottom = Math.round(this.props.width < this.props.height ? (this.props.width * 100) / this.props.height : (this.props.height * 100) / this.props.width);

            return (
                <div className={this.props.className + ` legacy-wrapper`} style={{ paddingBottom: paddingBottom + '%', width: this.props.width }}>
                    <div className="background-blur" style={{ backgroundImage: `url('${image}')` }}></div>
                    <img data-pin-nopin="true" src={image} alt={this.props.alt} />
                </div>
            )
        }

        const imageUrl = new URL(image);
        imageUrl.searchParams.set('fit', 'crop');
        imageUrl.searchParams.set('crop', 'focalpoint');
        imageUrl.searchParams.set('fp-x', stateData.focalX);
        imageUrl.searchParams.set('fp-y', stateData.focalY);
        imageUrl.searchParams.set('fp-z', stateData.focalZ);

        const imageMain = new URL(imageUrl);
        imageMain.searchParams.set('w', this.width);
        imageMain.searchParams.set('h', this.height);

        const imageLazy = new URL(imageMain);
        imageLazy.searchParams.set('px', '28');
        imageLazy.searchParams.set('q', '0');
        imageLazy.searchParams.set('colorquant', '16');

        // Prevent numbers to be last fix
        imageMain.searchParams.set('auto', 'format');
        imageLazy.searchParams.set('auto', 'format');

        return (
            <React.Fragment>
                <picture className={this.props.className} data-pin-nopin="true">
                    {Object.keys(stateData.sizes).map(function (sizeName, index) {
                        return <React.Fragment key={index}>
                            {stateData.formats.map(function (format, index) {
                                const src1x = new URL(image);
                                src1x.searchParams.set('fit', 'crop');
                                src1x.searchParams.set('crop', 'focalpoint');
                                src1x.searchParams.set('fp-x', stateData.focalX);
                                src1x.searchParams.set('fp-y', stateData.focalY);
                                src1x.searchParams.set('fp-z', stateData.focalZ);
                                src1x.searchParams.set('w', stateData.sizes[sizeName].width);
                                src1x.searchParams.set('h', stateData.sizes[sizeName].height);
                                src1x.searchParams.set('fm', format);

                                const src2x = new URL(src1x);
                                src2x.searchParams.set('dpr', '2');

                                return <source key={index} media={stateData.sizes[sizeName].media}
                                    type={`image/${format}`}
                                    data-srcset={
                                        `${src1x} 1x, ` +
                                        `${src2x} 2x`} />
                            })}
                        </React.Fragment>
                    })}
                    <img src={`${imageLazy}`}
                        data-src={`${imageMain}`}
                        alt={this.props.alt}
                        width={this.width}
                        height={this.height}
                        data-pin-nopin="true"
                        className="lazyload" />
                </picture>
            </React.Fragment>
        )
    }
}

export default Image;